// routes/_authenticated/fundos/screener.tsx — entry point for `/fundos/screener`.
// The page lives in `@/features/fundos/screener`; this file is just router glue.

import { createFileRoute } from "@tanstack/react-router";

import { FundosScreenerPage } from "@/features/fundos/screener";

export const Route = createFileRoute("/_authenticated/fundos/screener")({
  component: FundosScreenerPage,
});
